import script from "./ShadowHistoryConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./ShadowHistoryConfirmation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__